import { Component } from '@angular/core';
import { DemoRequestService } from 'src/app/dialogs/demo-choice-dialog/demo-request.service';

@Component({
  selector: 'app-ai-resume-evaluation-section',
  templateUrl: './ai-resume-evaluation-section.component.html',
  styleUrls: ['./ai-resume-evaluation-section.component.scss'],
})
export class AiResumeEvaluationSectionComponent {
  constructor(private demoRequestService: DemoRequestService) {}

  openDemoChoice() {
    this.demoRequestService.openDemoChoice();
  }
}
